import { render, staticRenderFns } from "./tableAbsensi.vue?vue&type=template&id=61d90133&scoped=true"
import script from "./tableAbsensi.vue?vue&type=script&lang=js"
export * from "./tableAbsensi.vue?vue&type=script&lang=js"
import style0 from "./tableAbsensi.vue?vue&type=style&index=0&id=61d90133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d90133",
  null
  
)

export default component.exports